import * as React from 'react';

function NewsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id='NewsIcon_svg__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      width='41'
      height='41'
      viewBox='0 0 235 235'
      xmlSpace='preserve'
      {...props}
    >
      <style>
        {'.NewsIcon_svg__st3{fill:#b95531}.NewsIcon_svg__st5{fill:#8aa7c3}'}
      </style>
      <path
        d='M117.5 235c64.9 0 117.5-52.6 117.5-117.5S182.4 0 117.5 0 0 52.6 0 117.5 52.6 235 117.5 235z'
        fill='#ffbf80'
      />
      <path
        d='M168.8 68.4l-83-23.7-4.2 14.7L69 55.8l-27.9 98-2.1 7.4c-.9 3.1.9 6.3 3.9 7.3.1 0 .2 0 .3.1H43l1.7.5 68.1 19.4 47.8 13.6c7 2 14.3-2.1 16.3-9.1l4.7-16.3 16.1-56.4-28.9-51.9z'
        opacity={0.3}
        fill='#414042'
      />
      <path
        d='M50 151.7l4.7-16.3 15.7-55.1 11.9-41.7 83 23.7 28.9 51.9-16.1 56.4-4.7 16.3c-2 7-9.3 11.1-16.3 9.1l-47.8-13.6L41.2 163l-1.7-.5c7.7.3 8.6-4.3 10.5-10.8z'
        fill='#fff'
      />
      <path
        className='NewsIcon_svg__st3'
        d='M153.8 102.7l40.4 11.5-28.9-51.9-11.5 40.4z'
      />
      <path d='M194.2 114.2l-40.4-11.5 28.9 51.9 11.5-40.4z' fill='#ffb8c0' />
      <path
        className='NewsIcon_svg__st3'
        d='M48.4 157.2l2.7-9.3 8.9-31.2 18.1-63.4-12.6-3.6-27.9 98-2.1 7.4c-.9 3.1.9 6.3 3.9 7.3 3.9 1 7.9-1.3 9-5.2z'
      />
      <path
        className='NewsIcon_svg__st5'
        d='M72.8 117.6l42.7 12.2 1.1-3.8-42.7-12.2-1.1 3.8zM81 88.9l-5 17.7 42.7 12.2 5-17.7L81 88.9zM92 50.3l-.5 1.7 64.1 18.3.5-1.7L92 50.3zM82.8 82.6l64.1 18.3.5-1.7-64.2-18.3-.4 1.7zM69.6 128.8l42.7 12.2 1.1-3.8L70.7 125l-1.1 3.8zM67.5 136.2l-1.1 3.8 42.7 12.2 1.1-3.8-42.7-12.2zM63.2 151.2l42.7 12.2 1.1-3.8-42.7-12.2-1.1 3.8zM125.7 128.6l-1.1 3.8 42.7 12.2 1.1-3.8-42.7-12.2zM122.5 139.8l-1.1 3.8 42.7 12.2 1.1-3.8-42.7-12.2zM118.2 154.8l42.7 12.2 1.1-3.8-42.7-12.2-1.1 3.8zM115 166l42.7 12.2 1.1-3.8-42.7-12.2-1.1 3.8z'
      />
      <path
        className='NewsIcon_svg__st3'
        d='M98.3 81l-3.9-1.1L92 65.5h-.1l-3.6 12.7-3.9-1.1 5.7-19.9 3.9 1.1 2.5 14.4h.1l3.6-12.7 3.9 1.1L98.3 81zM114.4 76.2l-6.7-1.9-1.6 5.6 7.8 2.2-.9 3.1-11.7-3.4L107 62l11.7 3.4-.9 3.1-7.8-2.2-1.4 5 6.7 1.9-.9 3zM130.5 82.4l5.8-12 3.8 1.1-9.5 18.8-3.6-1 .7-13h-.1l-6.2 11.4-3.6-1 1.8-21 3.8 1.1-1.6 13.2h.1l6.5-11.9 2.8.8-.7 13.5zM146.5 89.2c.2-.8.2-1.4-.1-2-.3-.6-.9-1.2-1.7-1.9-1.9-1.3-3.2-2.6-3.9-3.8-.8-1.2-.9-2.6-.5-4.3.5-1.6 1.4-2.8 2.9-3.5 1.5-.7 3.2-.8 5-.2 1.9.5 3.3 1.6 4.1 3 .9 1.5 1 3.1.5 4.8l-.1.1-3.8-1.1c.3-.9.2-1.7-.1-2.4-.3-.7-.9-1.2-1.7-1.4-.8-.2-1.4-.2-2 .2-.6.3-.9.9-1.2 1.6-.2.7-.1 1.3.3 1.8.4.6 1.1 1.3 2.1 2.1 1.7 1.2 2.9 2.4 3.6 3.6.7 1.2.8 2.7.3 4.4-.5 1.7-1.5 2.9-2.9 3.6-1.4.6-3.1.7-5 .1-1.9-.5-3.4-1.6-4.4-3.1-1.1-1.5-1.3-3.3-.7-5.3l.1-.1 3.8 1.1c-.4 1.2-.3 2.2 0 2.9.4.7 1.1 1.2 2.1 1.5.8.2 1.5.2 2-.1.8-.3 1.1-.9 1.3-1.6z'
      />
    </svg>
  );
}

export default NewsIcon;
